import { Axios as AxiosObservable } from 'axios-observable';
import { EMPTY } from 'rxjs';
export class BasketData {
    constructor(hrefResolverService, contentService) {
        this.hrefResolverService = hrefResolverService;
        this.contentService = contentService;
        this.compareApiUrl = this.hrefResolverService.getResolvedUrl('cwpScreenerApi');
    }
    get getCompareApiUrl() {
        return this.compareApiUrl;
    }
    set setCompareApiUrl(cwpScreenerApi) {
        this.compareApiUrl = cwpScreenerApi;
    }
    getProductData(portfolioIds) {
        if (!portfolioIds || !portfolioIds.length) {
            return EMPTY;
        }
        const theme = this.contentService.get('basket-api-config', 'ishares-basket');
        const portfolioIdsJoined = portfolioIds.join('|');
        const productDataServiceUrl = `${this.compareApiUrl}?config=${theme}&portfolioId=${portfolioIdsJoined}&siteEntryPassthrough=true`;
        return AxiosObservable.get(productDataServiceUrl);
    }
}
